__turbopack_context__.v({
  "arrow": "PhotoCarousel-module-scss-module__AItOWa__arrow",
  "carousel": "PhotoCarousel-module-scss-module__AItOWa__carousel",
  "controls": "PhotoCarousel-module-scss-module__AItOWa__controls",
  "counter": "PhotoCarousel-module-scss-module__AItOWa__counter",
  "photoButton": "PhotoCarousel-module-scss-module__AItOWa__photoButton",
  "thumbnail": "PhotoCarousel-module-scss-module__AItOWa__thumbnail",
  "thumbnailActive": "PhotoCarousel-module-scss-module__AItOWa__thumbnailActive",
  "thumbnails": "PhotoCarousel-module-scss-module__AItOWa__thumbnails",
});
